angular.module('core')
    .component('tableLoadingIndicators', {
        bindings: {
            page: '<'
        },
        template: `
            <div class="no-records" ng-if="$ctrl.page.fullListSize === 0" translate="norecords"></div>
            <div class="no-records" ng-if="!$ctrl.page.list"><i class="fa fa-spinner fa-spin fa-lg"></i></div>
        `
    })
    .component('arrayLoadingIndicators', {
        bindings: {
            array: '<'
        },
        template: `
            <div class="no-records" ng-if="$ctrl.array.length === 0" translate="norecords"></div>
            <div class="no-records" ng-if="!$ctrl.array"><i class="fa fa-spinner fa-spin fa-lg"></i></div>
        `
    })
